import React from 'react';
import SEOHelmet from '../SEOHelmet';

const ExpertPsychiatristSouthDelhi: React.FC = () => {
  return (
    <div className="bg-white text-pink-700 min-h-screen p-8">
      <SEOHelmet  />
      <h1 className="text-4xl font-bold mb-6">Dr. Bushra Zahoor - Psychiatrist in South Delhi</h1>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Comprehensive Psychiatric Care in South Delhi</h2>
        <p className="mb-4">Dr. Bushra Zahoor, MBBS (Gold Medalist), MD, DNB (Psychiatry), provides clinical psychiatric care for South Delhi at Asiaz Hospital. Her approach combines evidence-based medical knowledge with attentive care for a wide range of mental health concerns.</p>
      </section>
      <section className="mb-8">
        <h3 className="text-xl font-semibold mb-4">Specialized Treatments:</h3>
        <ul className="list-disc list-inside">
          <li>Bipolar Disorder Management</li>
          <li>Depression and Anxiety Treatment</li>
          <li>Counselling and Psychotherapy</li>
          <li>Psychosis and Other Mental Disorders</li>
          <li>Migraine Treatment</li>
          <li>Relationship Issues</li>
        </ul>
      </section>
      <section className="mb-8">
        <h3 className="text-xl font-semibold mb-4">Dr. Bushra's Expertise:</h3>
        <ul className="list-disc list-inside">
          <li>MBBS (Gold Medalist), MD (Psychiatry), DNB (Psychiatry)</li>
          <li>Specializes in complex mental health disorders</li>
          <li>Holistic approach to mental wellbeing</li>
          <li>Extensive experience in treating diverse psychological issues</li>
        </ul>
      </section>
      <section className="mb-8">
        <h3 className="text-xl font-semibold mb-4">Areas Served in South Delhi:</h3>
        <p>Nizamuddin, Nizamuddin East, Jangpura, Aliganj, Khan Market, Lajpat Nagar, Taimour Nagar, South West Delhi, and surrounding areas in Delhi NCR</p>
      </section>
      <section className="mb-8">
        <h3 className="text-xl font-semibold mb-4">Contact Information:</h3>
        <p>Phone: +91-9310330922</p>
        <p>Email: bushra.zhro7@gmail.com</p>
        <p>Address: Plot No. 140, Sector 15 Part 2, Near Mother Dairy, Gurugram, Haryana - 122001</p>
      </section>
      <section>
        <h3 className="text-xl font-semibold mb-4">Why Choose Dr. Bushra at Asiaz Hospital?</h3>
        <p>Dr. Bushra Zahoor offers a professional and confidential setting for clinical mental health care at Asiaz Hospital. Her integrative approach provides evidence-based care tailored to individual clinical requirements for conditions including depression, anxiety, relationship issues, and other psychiatric concerns.</p>
        <p className="mt-4">Psychiatric consultations are available for individuals in South Delhi. Schedule a consultation with Dr. Bushra Zahoor at Asiaz Hospital.</p>
      </section>
    </div>
  );
};

export default ExpertPsychiatristSouthDelhi;